import { SearchContext } from "context/SearchProvider/SearchProvider";
import { useContext } from "react";

export const useSearch = () => {
  return useContext(SearchContext);
};
